import React from 'react';
import PropTypes from 'prop-types';
import VisaIcon from '../../../../../../assets/images/icon--visa.svg';
import MasterCardIcon from '../../../../../../assets/images/icon--master_card.svg';
import PaypalIcon from '../../../../../../assets/images/paypal_p.svg';
import AmexIcon from '../../../../../../assets/images/icon--amex.svg';
import DinersIcon from '../../../../../../assets/images/icon--diners.svg';
import DiscoverIcon from '../../../../../../assets/images/icon--discover.svg';
import UnionpayIcon from '../../../../../../assets/images/icon--unionpay.svg';
import JcbIcon from '../../../../../../assets/images/icon--jcb.svg';
import BankIcon from '../../../../../../assets/images/icon--account_balance.svg';

const getIconSrc = (brand) => {
  switch (brand) {
    case 'visa':
      return VisaIcon;
    case 'mastercard':
      return MasterCardIcon;
    case 'amex':
      return AmexIcon;
    case 'diners':
      return DinersIcon;
    case 'discover':
      return DiscoverIcon;
    case 'jsb':
      return JcbIcon;
    case 'unionpay':
      return UnionpayIcon;
    case 'paypal':
      return PaypalIcon;
    default:
      return BankIcon;
  }
};

function PaymentBrandContent({ brand, lastDigits }) {
  return (
    <>
      <img
        style={{ width: '24px', height: '24px', marginRight: '4px' }}
        src={getIconSrc(brand)}
      />
      <span style={{ textTransform: 'capitalize' }}>{brand}</span>
      {lastDigits && <span>-{lastDigits}</span>}
    </>
  );
}

PaymentBrandContent.propTypes = {
  brand: PropTypes.string.isRequired,
  lastDigits: PropTypes.string,
};

export default PaymentBrandContent;
